import styled from "styled-components";

export const TeamMemberSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 45px;
  padding: 10px;
  flex-direction: column;
  /* height: 100vh; */
  margin: 10px;
  .secondary-navbar {
    background-color: #4285f4;
    padding: 0.5rem 2.5rem;
    display: flex;
    justify-content: center;
    color: #fff;
    font-weight: bold;
    border-radius: 10px;
  }

  .container {
    background-color: #f2f2f2;
    border-radius: 5px;
    width: 80%;
    height: 100%;
    margin: 1rem auto;
    padding: 2rem;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  }

  .heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 8px 0;
  }

  .headings {
    background-color: #4285f4;
    padding: 0.3rem 2rem;
    border-radius: 4px;
    color: #fff;
    font-weight: bold;
  }

  .goals-conatiner {
    margin-top: 3rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .goal-content {
    margin-top: 3rem;
    width: 100%;
    background-color: #fff;
    border-radius: 4px;
    align-content: center;
    padding: 2rem 4rem;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  label {
    align-self: flex-start;
    margin-top: 4px;
    color: #4285f4;
    font-weight: bold;
  }

  textarea {
    width: 50%;
    align-self: flex-start;
    border: none;
    padding: 8px;
    border-radius: 4px;
    background-color: #f2f2f2;
  }

  textarea:focus {
    outline: none;
    box-shadow: 0 0 10px #4285f4;
  }

  Button {
    margin-top: 4px;
    align-self: flex-start;
    padding: 0.6rem 0.1rem;
    margin-bottom: 5px;
    color: #fff;
    background-color: #4285f4;
    border: none;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
  }

  .project-lead-comment {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 1rem;
  }

  .button {
    align-self: center;
  }

  .editor {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  .goal {
    justify-self: flex-start;
    padding-top: 1rem;
  }
  .goal-container {
    width: 100%;
  }

  .button {
    display: flex;
    justify-content: center;
  }

  .tl-button {
    padding: 0.5rem 2rem;
  }
`;
